import { useEffect, useState } from 'react';
import { getRecentGames } from '../../../util/apis/GameAPI';
import { getNowPlayingMovie } from '../../../util/apis/MovieAPI';
import { getPlayingThisWeekTV } from '../../../util/apis/TvAPI';
import Button from '../../Button';
import {
  fetchMovies,
  fetchGames,
  fetchTvShows,
} from '../../../util/apis/Ourapi';

export default function RandomTab() {
  const [movies, setMovies] = useState([]);
  const [tvShows, setTvShows] = useState([]);
  const [games, setGames] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [movieData, tvData, gameData] = await Promise.all([
          fetchMovies(),
          fetchTvShows(),
          fetchGames(),
        ]);

        const isMoviesValid =
          Array.isArray(movieData?.result) && movieData.result.length > 0;
        const isTvShowsValid =
          Array.isArray(tvData?.result) && tvData.result.length > 0;
        const isGamesValid =
          Array.isArray(gameData?.result) && gameData.result.length > 0;

        if (isMoviesValid && isTvShowsValid && isGamesValid) {
          setMovies(movieData.result.slice(0, 5));
          setTvShows(tvData.result.slice(0, 5));
          setGames(gameData.result.slice(0, 4));
        } else {
          const [fallbackMovieData, fallbackTvData, fallbackGameData] =
            await Promise.all([
              getNowPlayingMovie.get(true),
              getPlayingThisWeekTV.get(true),
              getRecentGames.get(true),
            ]);

          // console.log('✅ Using fallback APIs (getNowPlayingMovie, getPlayingThisWeekTV, getRecentGames)');
          console.log(fallbackMovieData.results);
          setMovies(fallbackMovieData.results.slice(0, 5));
          setTvShows(fallbackTvData.results.slice(0, 5));
          setGames(fallbackGameData.results.slice(0, 4));
        }
      } catch (error) {
        console.log(
          '❌ Error fetching primary APIs. Switching to fallback APIs...',
          error,
        );

        try {
          const [fallbackMovieData, fallbackTvData, fallbackGameData] =
            await Promise.all([
              getNowPlayingMovie.get(true),
              getPlayingThisWeekTV.get(true),
              getRecentGames.get(true),
            ]);

          setMovies(fallbackMovieData.results.slice(0, 5));
          setTvShows(fallbackTvData.results.slice(0, 5));
          setGames(fallbackGameData.results.slice(0, 4));
        } catch (fallbackError) {
          console.log('❌ Fallback API fetch also failed...', fallbackError);
        }
      }
    };

    fetchData();
  }, []);

  return (
    <div className="w-full flex flex-col items-center p-4">
      {/* Trending Movies */}
      <div className="w-full">
        <h2 className="text-gray-200 text-2xl font-bold mb-4 text-center">
          Trending Movies 🎬
        </h2>
        <div className="grid place-items-center lg:grid-cols-4 md:grid-cols-4 sm:grid-cols-3 grid-cols-2 gap-y-2 gap-x-3 px-3 md:px-20 lg:px-40 2xl:grid-cols-5 ">
          {movies.map((movie) => (
            <a
              key={movie.id}
              href={`/rate/movie/${movie.id}`}
              className="relative mb-2 lg:w-64 rounded-xl overflow-hidden group"
            >
              {/* Movie Poster with Hover Effect */}
              <div className="relative">
                <img
                  src={`https://image.tmdb.org/t/p/original/${movie.poster_path}`}
                  className="w-full rounded-xl border-2 aspect-poster group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />

                {/* Dark Overlay for Readability */}
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition duration-300 rounded-xl"></div>

                {/* Movie Title */}
                <div className="absolute bottom-0 w-full text-white bg-black/10 px-3 py-2 text-center text-sm font-semibold group-hover:bg-black/80 transition duration-300">
                  {movie.title}
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>

      {/* Trending TV Shows */}
      <div className="w-full mt-10">
        <h2 className="text-gray-200 text-2xl font-bold mb-4 text-center">
          Trending TV Shows 📺
        </h2>
        <div className="grid place-items-center lg:grid-cols-4 md:grid-cols-4 sm:grid-cols-3 grid-cols-2 gap-y-2 gap-x-3 px-3 md:px-20 lg:px-40 2xl:grid-cols-5">
          {tvShows.map((show) => (
            <a
              key={show.id}
              href={`/rate/tv/${show.id}`}
              className="relative mb-2 lg:w-64 rounded-xl overflow-hidden group"
            >
              {/* Background Image */}
              <div className="relative">
                <img
                  src={`https://image.tmdb.org/t/p/original/${show.poster_path}`}
                  className="w-full rounded-xl border-2 aspect-poster group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                {/* <span className="absolute top-4 left-0 -rotate-45 bg-red-500 text-white py-0.5 px-4 rounded-lg text-xs">
                Movie 
              </span> */}

                {/* Dark Overlay */}
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition duration-300 rounded-xl"></div>

                {/* Show Name */}
                <div
                  className="absolute bottom-0 w-full text-white bg-black/10 px-3 py-2 text-center text-sm font-semibold
                 group-hover:bg-black/80 transition duration-300"
                >
                  {show.name}
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>

      {/* Trending Games */}
      <div className="w-full mt-10">
        <h2 className="text-gray-200 text-2xl font-bold mb-4 text-center">
          Trending Games 🎮
        </h2>
        <div className="grid place-items-center lg:grid-cols-4 md:grid-cols-4 sm:grid-cols-3 grid-cols-2 gap-y-2 gap-x-3 px-3 md:px-20 lg:px-40 2xl:grid-cols-5">
          {games.map((game) => (
            <a
              key={game.id}
              href={`/rate/game/${game.id}`}
              className="relative mb-2 lg:w-64 rounded-xl overflow-hidden group"
            >
              {/* Game Poster with Hover Effect */}
              <div className="relative">
                <img
                  src={game.background_image}
                  className="w-full rounded-xl border-2 aspect-backdrop group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />

                {/* Dark Overlay for Readability */}
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/30 transition duration-300 rounded-xl"></div>

                {/* Game Title */}
                <div className="absolute bottom-0 w-full text-white bg-black/10 px-3 py-2 text-center text-sm font-semibold group-hover:bg-black/80 transition duration-300">
                  {game.name}
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>

      {/* Find More Button */}
      <div className="flex justify-center py-5">
        <a href="/searchall">
          <Button variant="button" type="button">
            Find More
          </Button>
        </a>
      </div>
    </div>
  );
}
